import React, { Fragment, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Check from "~/components/Icons/icon_exclamation_mark";
import PanelWrapper from "~/components/PanelWrapper";

import s from "./BlockStaffInfo.less";
import clsx from "clsx";
import { EmployeeIProps } from "~/entity/Dealer/model/schema";
interface MainBlockStaffInfoIProps {
  isLoading: boolean;
  data: EmployeeIProps;
  error?: boolean;
}

const MainBlockStaffInfo: React.FC<MainBlockStaffInfoIProps> = ({
  isLoading,
  data,
  error,
}) => {
  const { t } = useTranslation();
  const toDay = new Date();
  toDay.setHours(23, 59, 59, 0);

  const history = useHistory();
  const onClick = useCallback(() => {
    history.push("/staff/");
  }, [history]);

  const getValueClass = (fact: number, standard: number) => {
    return fact >= standard ? s.greenValue : s.redValue;
  };

  return (
    <PanelWrapper
      width={220}
      height={220}
      label={t("dealers.staff_info")}
      clickable
      onClickLink={onClick}
      loading={isLoading}
      customClassName={s.staff_padding}
    >
      <div className={s.prof}>
        <div className={s.wrapper}>
          <ul className={s.list}>
            {!error &&
              data &&
              Object.entries(data).map(
                ([keys, value], id) =>
                  keys !== "__typename" &&
                  keys !== "isMalus" &&
                  keys !== "category" && (
                    <Fragment key={keys + id}>
                      <li className={s.active}>
                        <div className={s.left}>{t(`staff.${keys}`)}</div>
                      </li>
                      {Object.entries(value).map(
                        ([key, value], id2) =>
                          key !== "__typename" && (
                            <li
                              key={key + id2}
                              className={` ${
                                key === "fact"
                                  ? getValueClass(
                                      value as number,
                                      data[keys]?.standard
                                    )
                                  : ""
                              }`}
                            >
                              <div className={s.left}>{t(`staff.${key}`)}</div>
                              <div className={`${s.right}`}>
                                {value}
                                {key === "compliance" ? "%" : ""}
                              </div>
                            </li>
                          )
                      )}
                    </Fragment>
                  )
              )}
            {data && data.category !== undefined && (
              <li className={s.active}>
                <div className={s.left}>{t(`staff.category`)}</div>
                <div className={`${s.right}`}>{data?.category ?? 0}</div>
              </li>
            )}
          </ul>
        </div>
      </div>

      {
        <a href={"/staff/bonus"} onClick={(e) => e.stopPropagation()}>
          <div
            className={clsx(s.malusError, {
              [s.greenMalus]: !data?.isMalus,
            })}
          >
            {data?.isMalus && (
              <div>
                <Check />
              </div>
            )}
            <div className={s.malusWrap}>
              <div>
                {t("staff.malus")} -{" "}
                {data?.isMalus
                  ? t("appeal.malusStatusSelect.true")
                  : t("appeal.malusStatusSelect.false")}
              </div>
            </div>
          </div>
        </a>
      }
    </PanelWrapper>
  );
};

export default MainBlockStaffInfo;
